/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "நேற்று",
        "-2": "நேற்று முன் தினம்",
        "0": "இன்று",
        "1": "நாளை",
        "2": "நாளை மறுநாள்",
        "future": {
          "one": "{0} நாளில்",
          "other": "{0} நாட்களில்"
        },
        "past": {
          "one": "{0} நாளுக்கு முன்",
          "other": "{0} நாட்களுக்கு முன்"
        }
      },
      "day-narrow": {
        "-1": "நேற்று",
        "-2": "நேற்று முன் தினம்",
        "0": "இன்று",
        "1": "நாளை",
        "2": "நாளை மறுநாள்",
        "future": {
          "one": "{0} நா.",
          "other": "{0} நா."
        },
        "past": {
          "one": "{0} நா. முன்",
          "other": "{0} நா. முன்"
        }
      },
      "day-short": {
        "-1": "நேற்று",
        "-2": "நேற்று முன் தினம்",
        "0": "இன்று",
        "1": "நாளை",
        "2": "நாளை மறுநாள்",
        "future": {
          "one": "{0} நாளில்",
          "other": "{0} நாட்களில்"
        },
        "past": {
          "one": "{0} நாளுக்கு முன்",
          "other": "{0} நாட்களுக்கு முன்"
        }
      },
      "hour": {
        "0": "இந்த ஒரு மணிநேரத்தில்",
        "future": {
          "one": "{0} மணிநேரத்தில்",
          "other": "{0} மணிநேரத்தில்"
        },
        "past": {
          "one": "{0} மணிநேரம் முன்",
          "other": "{0} மணிநேரம் முன்"
        }
      },
      "hour-narrow": {
        "0": "இந்த ஒரு மணிநேரத்தில்",
        "future": {
          "one": "{0} ம.",
          "other": "{0} ம."
        },
        "past": {
          "one": "{0} ம. முன்",
          "other": "{0} ம. முன்"
        }
      },
      "hour-short": {
        "0": "இந்த ஒரு மணிநேரத்தில்",
        "future": {
          "one": "{0} மணி.",
          "other": "{0} மணி."
        },
        "past": {
          "one": "{0} மணி. முன்",
          "other": "{0} மணி. முன்"
        }
      },
      "minute": {
        "0": "இந்த ஒரு நிமிடத்தில்",
        "future": {
          "one": "{0} நிமிடத்தில்",
          "other": "{0} நிமிடங்களில்"
        },
        "past": {
          "one": "{0} நிமிடத்திற்கு முன்",
          "other": "{0} நிமிடங்களுக்கு முன்"
        }
      },
      "minute-narrow": {
        "0": "இந்த ஒரு நிமிடத்தில்",
        "future": {
          "one": "{0} நி.",
          "other": "{0} நி."
        },
        "past": {
          "one": "{0} நி. முன்",
          "other": "{0} நி. முன்"
        }
      },
      "minute-short": {
        "0": "இந்த ஒரு நிமிடத்தில்",
        "future": {
          "one": "{0} நிமி.",
          "other": "{0} நிமி."
        },
        "past": {
          "one": "{0} நிமி. முன்",
          "other": "{0} நிமி. முன்"
        }
      },
      "month": {
        "-1": "கடந்த மாதம்",
        "0": "இந்த மாதம்",
        "1": "அடுத்த மாதம்",
        "future": {
          "one": "{0} மாதத்தில்",
          "other": "{0} மாதங்களில்"
        },
        "past": {
          "one": "{0} மாதத்துக்கு முன்",
          "other": "{0} மாதங்களுக்கு முன்"
        }
      },
      "month-narrow": {
        "-1": "கடந்த மாதம்",
        "0": "இந்த மாதம்",
        "1": "அடுத்த மாதம்",
        "future": {
          "one": "{0} மா.",
          "other": "{0} மா."
        },
        "past": {
          "one": "{0} மா. முன்",
          "other": "{0} மா. முன்"
        }
      },
      "month-short": {
        "-1": "கடந்த மாதம்",
        "0": "இந்த மாதம்",
        "1": "அடுத்த மாதம்",
        "future": {
          "one": "{0} மாத.",
          "other": "{0} மாத."
        },
        "past": {
          "one": "{0} மாத. முன்",
          "other": "{0} மாத. முன்"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "கடந்த காலாண்டு",
        "0": "இந்த காலாண்டு",
        "1": "அடுத்த காலாண்டு",
        "future": {
          "one": "+{0} காலாண்டில்",
          "other": "{0} காலாண்டுகளில்"
        },
        "past": {
          "one": "{0} காலாண்டுக்கு முன்",
          "other": "{0} காலாண்டுகளுக்கு முன்"
        }
      },
      "quarter-narrow": {
        "-1": "இறுதி காலாண்டு",
        "0": "இந்த காலாண்டு",
        "1": "அடுத்த காலாண்டு",
        "future": {
          "one": "{0} கா.",
          "other": "{0} கா."
        },
        "past": {
          "one": "{0} கா. முன்",
          "other": "{0} கா. முன்"
        }
      },
      "quarter-short": {
        "-1": "இறுதி காலாண்டு",
        "0": "இந்த காலாண்டு",
        "1": "அடுத்த காலாண்டு",
        "future": {
          "one": "{0} காலா.",
          "other": "{0} காலா."
        },
        "past": {
          "one": "{0} காலா. முன்",
          "other": "{0} காலா. முன்"
        }
      },
      "second": {
        "0": "இப்போது",
        "future": {
          "one": "{0} விநாடியில்",
          "other": "{0} விநாடிகளில்"
        },
        "past": {
          "one": "{0} விநாடிக்கு முன்",
          "other": "{0} விநாடிகளுக்கு முன்"
        }
      },
      "second-narrow": {
        "0": "இப்போது",
        "future": {
          "one": "{0} வி.",
          "other": "{0} வி."
        },
        "past": {
          "one": "{0} வி. முன்",
          "other": "{0} வி. முன்"
        }
      },
      "second-short": {
        "0": "இப்போது",
        "future": {
          "one": "{0} விநா.",
          "other": "{0} விநா."
        },
        "past": {
          "one": "{0} விநா. முன்",
          "other": "{0} விநா. முன்"
        }
      },
      "week": {
        "-1": "கடந்த வாரம்",
        "0": "இந்த வாரம்",
        "1": "அடுத்த வாரம்",
        "future": {
          "one": "{0} வாரத்தில்",
          "other": "{0} வாரங்களில்"
        },
        "past": {
          "one": "{0} வாரத்திற்கு முன்",
          "other": "{0} வாரங்களுக்கு முன்"
        }
      },
      "week-narrow": {
        "-1": "கடந்த வாரம்",
        "0": "இந்த வாரம்",
        "1": "அடுத்த வாரம்",
        "future": {
          "one": "{0} வா.",
          "other": "{0} வா."
        },
        "past": {
          "one": "{0} வா. முன்",
          "other": "{0} வா. முன்"
        }
      },
      "week-short": {
        "-1": "கடந்த வாரம்",
        "0": "இந்த வாரம்",
        "1": "அடுத்த வாரம்",
        "future": {
          "one": "{0} வார.",
          "other": "{0} வார."
        },
        "past": {
          "one": "{0} வார. முன்",
          "other": "{0} வார. முன்"
        }
      },
      "year": {
        "-1": "கடந்த ஆண்டு",
        "0": "இந்த ஆண்டு",
        "1": "அடுத்த ஆண்டு",
        "future": {
          "one": "{0} ஆண்டில்",
          "other": "{0} ஆண்டுகளில்"
        },
        "past": {
          "one": "{0} ஆண்டிற்கு முன்",
          "other": "{0} ஆண்டுகளுக்கு முன்"
        }
      },
      "year-narrow": {
        "-1": "கடந்த ஆண்டு",
        "0": "இந்த ஆண்டு",
        "1": "அடுத்த ஆண்டு",
        "future": {
          "one": "{0} ஆ.",
          "other": "{0} ஆ."
        },
        "past": {
          "one": "{0} ஆ. முன்",
          "other": "{0} ஆ. முன்"
        }
      },
      "year-short": {
        "-1": "கடந்த ஆண்டு",
        "0": "இந்த ஆண்டு",
        "1": "அடுத்த ஆண்டு",
        "future": {
          "one": "{0} ஆண்டில்",
          "other": "{0} ஆண்டுகளில்"
        },
        "past": {
          "one": "{0} ஆண்டிற்கு முன்",
          "other": "{0} ஆண்டுகளுக்கு முன்"
        }
      }
    },
    "locale": "ta-LK"
  });
}